import { actions } from 'app-webtech-core';
import { PLAYER_CONTENT_KIND } from 'app-webtech-core/modules/player/constants';

export const viralPlayItemThunkAction = (content) => async (dispatch, getState) => {
  dispatch(
    actions.player.load({
      kind: PLAYER_CONTENT_KIND.VIRAL,
      id: content.id,
      slug: content.slug,
    }),
  );
};
